import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages
    //lazy load images
    lozad('.lozad', {
      rootMargin: '500px 0px',
      load: function(el) {
          el.src = el.dataset.src;
          el.onload = function() {
              el.classList.add('lozad-fade');
          }
      },
    }).observe()

    var flag = '<svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 100 66.67"><defs><style>.f4f8c037-cc92-42ea-a85b-dba47e2fcaf2{fill:#fedc00}</style></defs><g id="99c1f5a8-f5dd-4532-affc-803dd688be2d" data-name="Layer 2"><g id="0888dae3-ede3-497d-bff9-188968dd28c2" data-name="Layer 1"><g id="5b5b12e1-c71a-4805-8cea-5c7577795054" data-name="Layer 2"><path fill="#dc2f27" d="M0 0h100v66.67H0z"></path><path id="dd79e92d-c268-4b60-b512-a2f70b0237bc" data-name="path3374" class="f4f8c037-cc92-42ea-a85b-dba47e2fcaf2" d="M30.82 4.48l1.25 2.07-1.59 1.83 2.36-.54 1.24 2.08.22-2.42 2.36-.5-2.23-1 .21-2.41-1.59 1.84z"></path><path id="6e8a4432-a96c-4927-8410-e2838f74fcda" data-name="path3433" class="f4f8c037-cc92-42ea-a85b-dba47e2fcaf2" d="M16.67 6.67l-2.25 6.91H7.16L13 17.85l-2.25 6.91 5.88-4.27 5.88 4.27-2.21-6.91 5.88-4.27h-7.27z"></path><path id="92def13b-c970-456e-8a94-94e209e7b130" data-name="path3447" class="f4f8c037-cc92-42ea-a85b-dba47e2fcaf2" d="M38.54 10.34l.34 2.4-2.18 1.06 2.39.42.34 2.4 1.14-2.14 2.38.41-1.69-1.74L42.4 11l-2.18 1.07z"></path><path id="ba9a6ce9-e671-4668-aa4f-7d83ee1555f8" data-name="path3453" class="f4f8c037-cc92-42ea-a85b-dba47e2fcaf2" d="M34.51 26.88L33 28.77l-2.27-.85 1.33 2-1.51 1.89 2.34-.64 1.33 2 .11-2.41 2.33-.65-2.26-.81z"></path><path id="b88b1dae-fa2d-4d1e-90f9-48fbca27caf3" data-name="path3475" class="f4f8c037-cc92-42ea-a85b-dba47e2fcaf2" d="M39.88 20l-.66 2.33-2.42.09 2 1.35-.67 2.33 1.91-1.49 2 1.35-.83-2.28 1.9-1.49-2.42.09z"></path></g></g></g></svg>';

    $('#menu-primary .menu-item:last-child a').html(flag);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js